/**
 * RTK Query endpoints — Tenant features
 *
 * Migrated from: src/redux/features/actions.js + middleware/features.js
 *
 * The backend returns a map `{ ft_xxx: true|false, ... }` keyed by feature id.
 * Defaults to `FeaturesMap` (all-false) before the first response so consumers
 * can render synchronously without an undefined check.
 */

import { baseApi } from './baseApi';
import { FeaturesMap } from '../../entities/features';

const featuresApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    features: builder.query({
      query: () => ({ url: '/su/features', method: 'GET' }),
      transformResponse: (data) => data || FeaturesMap,
      providesTags: [{ type: 'Feature', id: 'MAP' }],
      keepUnusedDataFor: 60 * 60, // tenant features rarely change; keep an hour
    }),
  }),
  overrideExisting: false,
});

export const { useFeaturesQuery } = featuresApi;

/**
 * `useIsFeatureEnabled(featureId)` — convenience hook replacing the legacy
 * `useSelector(selectIsFeatureEnabled(id))`. Returns `false` while the query
 * is still loading.
 */
export function useIsFeatureEnabled(featureId) {
  const { data } = useFeaturesQuery();
  return Boolean(data && data[featureId] === true);
}

export default featuresApi;
